import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { productFetch } from '../features/ProductSlice';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MessageBox';
import Rating from '../components/Rating';
import Product from '../components/Product';
import { getSeller } from '../features/SellerSlice';
import { IMAGE_URL } from '../components/utils';

function SellerScreen () {
    const { id } = useParams();
    const dispatch = useDispatch();
   
    const {seller, status, error} = useSelector(state => state.sellerData);
    
    const products = useSelector(state => state.products);
    const {items, status: productStatus, error: productError} = products;
    
    useEffect(() => {
        dispatch(getSeller({id: id, by_seller: false}));
        dispatch(productFetch({seller:id}));
    }, [dispatch, id]);
    return (
        <div className='row top'>
            <div className='col-1'>
                { status === "pending" && (<LoadingBox>Loading...</LoadingBox>)}
                {status === "rejected" && (<MessageBox variant="danger">{error}</MessageBox>)}
                { status === "success" &&
                (
                    <ul className="card card-body">
                        <li>
                            <div className="row start">
                                <div className="p-1">
                                    <img className="small" src={IMAGE_URL + seller.logo} alt={seller.name} />
                                </div>
                                <div className="p-1">
                                    <h1>{seller.name}</h1>
                                </div>
                            </div>
                        </li>
                        <li>
                            <Rating rating={seller.rating} numReviews={seller.num_reviews} >

                            </Rating>
                        </li>
                        <li>
                            <a href={`mailto:${seller.email}`}>Contact Seller</a>
                        </li>
                        <li>
                            {seller.description}
                        </li>
                    </ul>
                )
                }
            </div>
            <div className='col-3'>
                { productStatus === "pending" && (<LoadingBox>Loading...</LoadingBox>)}
                {productStatus === "rejected" && (<MessageBox variant="danger">{productError}</MessageBox>)}
                { productStatus === "fulfilled" && (
                    <>
                    {items.length === 0 && <MessageBox>No Product Found</MessageBox>}
                    <div className="row center">
                        {items.map((item) => (
                            <Product key={item.id} product={item}></Product>
                        ))}
                    </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default SellerScreen
